(ns dre.modals.my-searches.signals.views
  (:require
   ["antd" :refer [Spin]]
   [clojure.string :as str]
   [dre.coll :refer [deep-merge]]
   [dre.components.dropdown :refer [dropdown dropdown-list]] 
   [dre.components.icons-iconoir :refer [icoinor-icon]]
   [dre.components.inputs :refer [checkbox input-text input-textarea]]
   [dre.components.form :refer [form form-item]]
   [dre.components.searchbar.events :as searchbar-events]
   [dre.components.searchbar.subs :as searchbar-subs]
   [dre.components.searchbar.views :refer [searchbar]]
   [dre.components.search-results.db :as results-db]
   [dre.i18n.views :refer [tr]]
   [dre.modals.my-searches.signals.events :as events]
   [dre.modals.modal-window :refer [modal-window]]
   [dre.page-util :as page-util]
   [dre.utils.bem :as bem]
   [re-frame.core :as rf]))

(def default-edit-settings
  {:email? false
   :email {:frequency "daily"
           :articles "5"
           :notify-when-zero? false
           :changed? true}})

(def frequency-options
  ["daily" "weekly" "biweekly" "monthly"])

(def recent-options
  ["5" "all"])

(defn input-settings
  [settings]
  (let [email? (get-in settings [:email?])
        articles (get-in settings [:email :articles])
        freq (get-in settings [:email :frequency])
        notify-when-zero? (get-in settings [:email :notify-when-zero?])
        changed? (get-in settings [:email :changed?])]
    [:<>
     [form
      [form-item
       {}
       [checkbox
        {:checked email?
         :on-change #(rf/dispatch [::events/update-data-edit [:signal/settings :email?] (not email?)])}
        [tr "Email notification"]]]
      (when email?
        [:<>
         [form-item
          {:label [tr "Frequency"]}
          [dropdown
           {:alignment :left
            :anchor
            [:button
             {:class (bem/bm :button [:light :small])}
             freq
             (icoinor-icon :nav-arrow-down)]
            :content
            [dropdown-list
             (for [v frequency-options]
               ^{:key v}
               [:a
                {:on-click #(rf/dispatch [::events/update-data-edit [:signal/settings :email :frequency] v])}
                v])]}]]
         [form-item
          {:label [tr "Most recent articles"]}
          [dropdown
           {:alignment :left
            :anchor
            [:button
             {:class (bem/bm :button [:light :small])}
             articles
             (icoinor-icon :nav-arrow-down)]
            :content
            [dropdown-list
             (for [v recent-options]
               ^{:key v}
               [:a
                {:on-click #(rf/dispatch [::events/update-data-edit [:signal/settings :email :articles] v])}
                v])]}]]
         [form-item
          {}
          [checkbox
           {:checked changed?
            :on-change #(rf/dispatch [::events/update-data-edit [:signal/settings :email :changed?] (not changed?)])}
           [tr "Include changed articles"]]]
         [form-item
          {}
          [checkbox
           {:checked notify-when-zero?
            :on-change #(rf/dispatch [::events/update-data-edit [:signal/settings :email :notify-when-zero?] (not notify-when-zero?)])}
           [tr "Receive update for saved search when no new items"]]]])]]))

(defn- saved-search-edit-searchbar
  []
  (let [db-root-path [:modals :my-searches :signals :data-edit]
        search-query (rf/subscribe [::searchbar-subs/search-query db-root-path])
        suggestions (rf/subscribe [::searchbar-subs/suggestions db-root-path])
        hint (rf/subscribe [::searchbar-subs/search-input-hint db-root-path])
        on-type (page-util/debounce2 #(rf/dispatch-sync [::searchbar-events/fetch-suggestions db-root-path %]) 125)
        on-submit (constantly nil)
        clear-query #(do
                       (rf/dispatch [::searchbar-events/clear-query db-root-path])
                       (rf/dispatch [::searchbar-events/clear-counts db-root-path]))]
    [searchbar {:db-root-path db-root-path
                :query search-query
                :suggestions suggestions
                :hint hint 
                :on-type on-type
                :on-submit on-submit 
                :clear-query clear-query
                :show-buttons? false}]))

(defn- edit-content
  []
  (let [component-name :edit-saved-search
        global-settings @(rf/subscribe [::events/global-settings])
        global-settings-loading? (= :loading @(rf/subscribe [::events/global-settings-state]))
        data @(rf/subscribe [::events/data-edit])
        uuid (:signal/uuid data)
        new? (not uuid)
        order (:query/order (:query/search-query data))
        selected-order (get (results-db/order-options-index) (if (contains? (results-db/order-options-index) (keyword order))
                                                             (keyword order)
                                                             results-db/default-order))
        settings (if new?
                   (deep-merge
                    global-settings
                    (get data :signal/settings {}))
                   (deep-merge
                    default-edit-settings
                    (get data :signal/settings {})))]
    (if global-settings-loading?
      [:div
       {:class [component-name]
        :style {:width "100%" :display "flex" :justify-content "center"}}
       [:> Spin]]
      [:div
       {:class [component-name]
        :style {:width "100%"}}
       [form
        {:layout "vertical"}
        [:<>
         [form-item
          {:label [tr "Title*"]}
          [input-text {:on-change #(rf/dispatch [::events/update-data-edit [:signal/title] (-> % .-target .-value)])
                       :value (:signal/title data)}]]
         [form-item
          {:label [tr "Description (Optional)"]}
          [input-textarea {:on-change #(rf/dispatch [::events/update-data-edit [:signal/description] (-> % .-target .-value)])
                           :value (:signal/description data)}]]
      ;;  TODO change style + on change event
         [form-item
          {:label [tr "Query*"]}
          [saved-search-edit-searchbar]]]]
       [form
        {:layout "horizontal"}
        [:<>
         [form-item
          {:label [tr "Order"]}
          [dropdown
           {:alignment :left
            :anchor
            [:button
             {:class (bem/bm :button [:light :large])}
             [tr (:label selected-order)]
             (icoinor-icon :nav-arrow-down)]
            :content
            [dropdown-list
             (for [{:keys [id label]} (results-db/order-options)]
               ^{:key id}
               [:a
                {:on-click #(rf/dispatch [::events/update-data-edit [:query/search-query :query/order] id])}
                [tr label]])]}]]]]
       [input-settings settings]])))


(defn edit-view
  []
  (let [data @(rf/subscribe [::events/data-edit])
        uuid (:signal/uuid data)
        new? (not uuid)
        global-settings @(rf/subscribe [::events/global-settings])
        on-ok
        #(let [signal data
               signal (assoc signal :query/search-query
                             (merge (:search-query data) {:query/order (get-in data [:query/search-query :query/order])}))
               signal (assoc signal
                             :signal/settings (if new?
                                                (deep-merge
                                                 global-settings
                                                 (get data :signal/settings {}))
                                                (deep-merge
                                                 default-edit-settings
                                                 (get data :signal/settings {}))))]
           (rf/dispatch (if new?
                          [::events/add signal]
                          [::events/edit uuid signal])))]
    [modal-window
     {:title (if new? "Create Saved Search" "Edit Saved Search")
      :content edit-content
      :submit? true
      :submit-text (if new? [tr "Create"] [tr "Edit"])
      :submit-disabled? (or (nil? (:query/pills (:search-query data))) (empty? (:signal/title data)))
      :on-submit on-ok}]))

(defn- delete-content
  []
  (let [data @(rf/subscribe [::events/data-delete])]
    [:div
     [:div
      [tr "You are about to delete the signals with titles: "]
      (str/join ", " (map :title data))
      "."]
     [:div
      [tr "Do you want to proceed?"]]]))

(defn confirm-delete-view
  []
 [modal-window
  {:title "Confirm Delete"
   :content delete-content
   :delete? true
   :on-delete #(rf/dispatch [::events/delete (mapv :uuid  @(rf/subscribe [::events/data-delete]))])}])
